// extracted by mini-css-extract-plugin
export default {"section-action":"CustomFormTable_section-action__ZkoYp","total-quantity":"CustomFormTable_total-quantity__dT4+r"};